/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { InView } from "react-intersection-observer";

export const VerticalTimelineElement = ({
  children = null,
  className = "",
  contentStyle = null,
  date = "",
  image = undefined,
  dateClassName = "",
  imageClassName = "",
  icon = null,
  iconClassName = "",
  iconOnClick = null,
  onTimelineElementClick = null,
  iconStyle = null,
  id = "",
  position = "",
  style = null,
  textClassName = "",
  intersectionObserverProps = {
    rootMargin: "0px 0px -40px 0px",
    triggerOnce: true,
  },
  visible = false,
  shadowSize = "small", // small | medium | large
}) => (
  <InView {...intersectionObserverProps}>
    {({ inView, ref }) => (
      <div
        ref={ref}
        id={id}
        className={classnames(className, "vertical-timeline-element", {
          "vertical-timeline-element--left": position === "left",
          "vertical-timeline-element--right": position === "right",
          "vertical-timeline-element--no-children": children === "",
        })}
        style={style}
      >
        <React.Fragment>
          <span // eslint-disable-line jsx-a11y/no-static-element-interactions
            style={iconStyle}
            onClick={iconOnClick}
            className={classnames(
              iconClassName,
              "vertical-timeline-element-icon",
              `shadow-size-${shadowSize}`, // for shadow size
              {
                "bounce-in": inView || visible,
                "is-hidden": !(inView || visible),
              },
            )}
          >
            {icon}
          </span>
          <div
            style={contentStyle}
            onClick={onTimelineElementClick}
            className={classnames(
              textClassName,
              "vertical-timeline-element-content",
            )}
          >
            <span
              style={{ textTransform: "uppercase" }}
              className={classnames(
                dateClassName,
                "vertical-timeline-element-date",
              )}
            >
              {date}
            </span>
            {children}

            <img
              className={classnames(
                imageClassName,
                "vertical-timeline-element-image",
              )}
              src={image}
            />
          </div>
        </React.Fragment>
      </div>
    )}
  </InView>
);

VerticalTimelineElement.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  contentArrowStyle: PropTypes.shape({}),
  contentStyle: PropTypes.shape({}),
  date: PropTypes.node,
  dateClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  icon: PropTypes.element,
  iconClassName: PropTypes.string,
  iconStyle: PropTypes.shape({}),
  iconOnClick: PropTypes.func,
  onTimelineElementClick: PropTypes.func,
  id: PropTypes.string,
  position: PropTypes.string,
  style: PropTypes.shape({}),
  textClassName: PropTypes.string,
  visible: PropTypes.bool,
  shadowSize: PropTypes.string,
  intersectionObserverProps: PropTypes.shape({
    root: PropTypes.object,
    rootMargin: PropTypes.string,
    threshold: PropTypes.number,
    triggerOnce: PropTypes.bool,
  }),
};
